import { datadogRum } from '@datadog/browser-rum';
import { get } from 'lodash';
import type { FieldPath } from 'react-hook-form';
import type { AgentFields } from '@/views/Referrals/views/NewReferral/types';
import { identityApi } from '$api-clients';

export async function fetchBrokerageName(
  teamId: string,
  userId: string,
): Promise<string | null> {
  const { data, error } = await identityApi.GET(
    '/teams/{teamId}/members/{userId}/brokerage',
    { params: { path: { teamId, userId } } },
  );

  if (error !== undefined) {
    datadogRum.addError(
      new Error(`Failed to fetch brokerage for team member ${userId}`, {
        cause: error,
      }),
    );
    return null;
  }

  return data?.name ?? null;
}

const ALWAYS_REQUIRED_FIELDS: FieldPath<AgentFields>[] = [
  'firstName',
  'lastName',
  'licenseNumber',
  'brokerage.companyName',
];

const EXTERNAL_AGENT_REQUIRED_FIELDS: FieldPath<AgentFields>[] = [
  'email',
  'cellPhone',
  'supervisingBroker.firstName',
  'supervisingBroker.lastName',
  'supervisingBroker.email',
  'brokerage.licenseNumber',
  'brokerage.street1',
  'brokerage.city',
  'brokerage.state',
  'brokerage.zip',
];

export function isValidAgentContact(agent: AgentFields) {
  const isExternalAgent = !agent?.userId;
  const requiredKeys = [
    ...ALWAYS_REQUIRED_FIELDS,
    ...(isExternalAgent ? EXTERNAL_AGENT_REQUIRED_FIELDS : []),
  ];

  return requiredKeys.every((key) => Boolean(get(agent, key)));
}
